import React from "react";
import ReactDatePicker from "react-datepicker";
import { DropdownToggle, Label } from "reactstrap";
import { CalenderIcon } from "../Icon";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NewDownloadIcon, UnfilledDatesIcon } from "../../assets/images";
import { HolidaysTimeSheetDataType } from "../../screens/TimeSheet";

type AppProps = {
  date: Date | string;
  handleDateChange: (data: any, name: string) => void;
  handleOpenTimeSheetUserView: () => void;
  handleOpenTimeSheetUnfilledDate: () => void;
  timeSheetError: any;
  setTimeSheetDate: any;
  holidaysData: HolidaysTimeSheetDataType[];
};

const TimeSheetHeader = ({
  date,
  handleDateChange,
  timeSheetError,
  setTimeSheetDate,
  handleOpenTimeSheetUserView,
  handleOpenTimeSheetUnfilledDate,
  holidaysData,
}: AppProps) => {
  const { dateError } = timeSheetError;
  return (
    <>
      <div
        className="col-md-8"
        style={{ display: "flex", justifyContent: "end" }}
      >
        <div
          onClick={() =>
            setTimeSheetDate(
              `${new Date().getDate().toString().padStart(2, "0")}-${(
                new Date().getMonth() + 1
              )
                .toString()
                .padStart(2, "0")}-${new Date().getFullYear()}`
            )
          }
          className="white-outline-button"
        >
          Today
        </div>
        <div className="form-group mr-7">
          <div className="date-picker-wraper mr-0 position-relative">
            <Label className="m-0 p-0 w-100">
              <ReactDatePicker
                dateFormat="dd-MM-yyyy"
                // holidays={holidaysData}
                selected={
                  date
                    ? new Date(
                        moment(`${date}T00:00:00`, "DD-MM-YYYY").format(
                          "YYYY-MM-DD[T]HH:mm:ss"
                        )
                      )
                    : null
                }
                onChange={(e: any) => {
                  handleDateChange?.(
                    e ? moment(e).format("DD-MM-YYYY") : null,
                    "time-sheet-date"
                  );
                }}
                fixedHeight
                showMonthDropdown
                showYearDropdown
                name="dateOfInvoice"
                placeholderText="Choose Date"
                className="form-control pointer"
              />
              <span
                className="calender-icon"
                style={{ right: "10px", cursor: "pointer" }}
              >
                <CalenderIcon />
              </span>
            </Label>

            <div>
              {!!dateError && (
                <small className="text-danger">{dateError}</small>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-md-4"
        style={{ display: "flex", justifyContent: "end" }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Missing Timesheet Report
            </Tooltip>
          }
        >
          <button
            className="btn form-control col-md-2 mr-3"
            style={{ border: "1px solid #bfcbe1" }}
            onClick={handleOpenTimeSheetUnfilledDate}
          >
            <img src={UnfilledDatesIcon} alt="contact icon" />
          </button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">Download Report</Tooltip>
          }
        >
          <button
            className="btn form-control col-md-2 "
            style={{ border: "1px solid #bfcbe1" }}
            onClick={handleOpenTimeSheetUserView}
          >
            <img src={NewDownloadIcon} alt="download icon" />
          </button>
        </OverlayTrigger>

        {/*  */}
      </div>
    </>
  );
};

export default TimeSheetHeader;
